/* This example requires Tailwind CSS v2.0+ */

import VaultLogo from './images/VaultLogo.png'
import icplogo from './images/icplogo.png'
import beticon from './images/beticon.png'
import graphicon from './images/graphicon.png'
import blockchainicon from './images/blockchainicon.png'

const features = [
  {
    name: 'A Better Way to Bet',
    description:
      'Our mission is to bring betting into the modern day with a peer-to-peer betting system that works entirely on-chain. With Vault, you buy and sell bets on sporting events so that the market, not the house, decides the odds.',
    icon: beticon,
  },
  {
    name: 'Powered by ICP',
    description:
      'Vault uses the Internet Computer Protocol to offer a fully decentralised platform (you are on it right now). Trade with confidence through cannister smart contract technology at a fraction of the cost of centralised betting. Learn more here.',
    icon: icplogo,
    href: 'https://internetcomputer.org/',
  },
  {
    name: 'How it works?',
    description:
      'Buyers and sellers compete on pricing to reflect market expectations. Once a bet is struck, your position is tokenised and its value can continue to change as the game approaches and plays out. Sell your position or ride out the highs and lows of the market to collect your potential payoff.',
    icon: blockchainicon,
  },
  {
    name: 'The fun part!',
    description:
      'Watch your bets rise and fall as Vault traders react to news and in-game action. Use your sports expertise to stand out and beat the market!',
    icon: graphicon,
  },
]

export default function Example() {
  return (
    <div className="lg:py-4 sm:py-0">
      <div className="bg-white bg-opacity-60 rounded-md mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto py-5 flex-shrink-0 flex justify-center">
          <img
            className="block h-20 w-auto"
            src={VaultLogo}
            alt='logo'
          />
        </div>
        <div className=" text-center">

          <p className="mt-4 font-bold leading-8 tracking-tight text-gray-900 text-4xl">
            The Decentralised Sports Betting Exchange
          </p>
        </div>

        <div className=" mt-10 py-10 rounded-lg">
          <dl className="space-y-10 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10 md:space-y-0">
            {features.map((feature) => (
              <div key={feature.name} className="relative">
                <dt>
                  <div className="flex w-0 flex-1">
                    <div className="absolute flex h-14 w-14 items-center justify-center rounded-md text-black">
                      <a href={feature.href} target="_blank" rel="noreferrer">
                        <img
                          className="h-16 w-16"
                          src={feature.icon}
                          alt='icon'

                        />
                      </a>
                    </div>
                  </div>

                  <p className="ml-16 py-4 px-4 text-lg font-medium leading-6 text-black">{feature.name}</p>
                </dt>
                <a href={feature.href} target="_blank" rel="noreferrer">
                <dd className="text-justify mt-2 ml-16 text-base text-black">{feature.description}</dd>
                </a>
              </div>
            ))}
          </dl>
        </div>
        <a href="/home" className="text-center">
          <h2  className="text-2xl font-semibold text-black hover:text-purple-600 pb-1">Coming soon... For now have an explore.</h2>
        </a>
        
        
      </div>
    </div>
  )
}